import { svgPaths, facilitySvgPaths, menuSvgPaths, parkingSvgPaths, LogoContainer, EventContainer, MainContainer } from '../../imports/svgPaths';
import { useState } from 'react';
import { menuItems } from '../../constants/menuData';
// import.*from.*imports/svg-8txpwpskyh";

interface MenuSectionProps {
  onMenuClick: () => void;
}

// Menu Section Title
function Container9() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-10 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-nowrap"
      data-name="Container"
    >
      <div className="font-paperlogy font-bold relative shrink-0 text-[0px] text-left text-neutral-950 tracking-[-0.96px]">
        <p className="leading-[normal] text-[min(48px,_7vw)] text-nowrap whitespace-pre">
          <span className="font-paperlogy font-extrabold font-bold">
            배가 든든
          </span>
          <span className="adjustLetterSpacing font-paperlogy font-medium">
            해야 더 신나게 놀아요
          </span>
        </p>
      </div>
      <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#333333] text-[min(20px,_4vw)] text-left tracking-[-0.4px] whitespace-pre">
        <p className="adjustLetterSpacing block mb-0">
          신나게 놀이하다가 배가 고플 때,
        </p>
        <p className="adjustLetterSpacing block">
          든든한 식사부터 간식까지 편하게 드실 수 있어요
        </p>
      </div>
    </div>
  );
}

// Menu Tab Buttons
function ButtonContainer5({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333]' 
          : 'bg-transparent hover:bg-gray-50'
      }`}
      data-name="Button Container"
    >
      {!isActive && (
        <div
          aria-hidden="true"
          className="absolute border border-[#cccccc] border-solid inset-0 pointer-events-none rounded-[100px] hover:border-[#aaaaaa]"
        />
      )}
      <div className={`font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px] ${
        isActive ? 'text-[#ffffff]' : 'text-[#333333]'
      }`}>
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          식사류
        </p>
      </div>
    </button>
  );
}

function ButtonContainer6({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333]' 
          : 'bg-transparent hover:bg-gray-50'
      }`}
      data-name="Button Container"
    >
      {!isActive && (
        <div
          aria-hidden="true"
          className="absolute border border-[#cccccc] border-solid inset-0 pointer-events-none rounded-[100px] hover:border-[#aaaaaa]"
        />
      )}
      <div className={`font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px] ${
        isActive ? 'text-[#ffffff]' : 'text-[#333333]'
      }`}>
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          간식류
        </p>
      </div>
    </button>
  );
}

function ButtonContainer7({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333]' 
          : 'bg-transparent hover:bg-gray-50'
      }`}
      data-name="Button Container"
    >
      {!isActive && (
        <div
          aria-hidden="true"
          className="absolute border border-[#cccccc] border-solid inset-0 pointer-events-none rounded-[100px] hover:border-[#aaaaaa]"
        />
      )}
      <div className={`font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px] ${
        isActive ? 'text-[#ffffff]' : 'text-[#333333]'
      }`}>
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          음료
        </p>
      </div>
    </button>
  );
}

function Container10({ activeTab, onTabChange }: {
  activeTab: 'all' | 'meals' | 'snacks' | 'drinks';
  onTabChange: (tab: 'all' | 'meals' | 'snacks' | 'drinks') => void;
}) {
  return (
    <div
      className="box-border content-stretch flex flex-row gap-2 items-start justify-start opacity-80 p-0 relative shrink-0"
      data-name="Container"
    >
      <ButtonContainer5 isActive={activeTab === 'meals'} onClick={() => onTabChange('meals')} />
      <ButtonContainer6 isActive={activeTab === 'snacks'} onClick={() => onTabChange('snacks')} />
      <ButtonContainer7 isActive={activeTab === 'drinks'} onClick={() => onTabChange('drinks')} />
    </div>
  );
}

function Container11({ activeTab, onTabChange }: {
  activeTab: 'all' | 'meals' | 'snacks' | 'drinks';
  onTabChange: (tab: 'all' | 'meals' | 'snacks' | 'drinks') => void;
}) {
  return (
    <div
      className="box-border content-stretch flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 lg:gap-0 p-0 relative shrink-0 w-full"
      data-name="Container"
    >
      <Container9 />
      <Container10 activeTab={activeTab} onTabChange={onTabChange} />
    </div>
  );
}

// Product Image Component - 여백을 주어 내부 이미지 크기만 조정하여 화질 개선
function ProductImage({ image }: { image: string }) {
  return (
    <div className="relative shrink-0 w-[min(220px,_20vw)] h-[min(220px,_20vw)] bg-white rounded-lg overflow-hidden border border-gray-100 p-4" data-name="Product Image">
      <div
        className="bg-center bg-contain bg-no-repeat h-full w-full"
        style={{ backgroundImage: `url('${image}')` }}
      />
    </div>
  );
}

// Product Card Component
function ProductCard({ image, name }: { image: string; name: string }) {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-3 h-[min(280px,_30vw)] items-center justify-center p-0 relative shrink-0 w-[min(220px,_20vw)]"
      data-name="Product Card"
    >
      <ProductImage image={image} />
      <div
        className="font-paperlogy font-normal leading-[0] w-full not-italic relative shrink-0 text-[min(16px,_3vw)] text-center text-neutral-950 tracking-[-0.32px]"
      >
        <p className="block leading-[normal] px-2">{name}</p>
      </div>
    </div>
  );
}

// Menu Grid Container
function Container12({ currentIndex, onPrev, onNext, maxIndex, displayMenuItems }: {
  currentIndex: number;
  onPrev: () => void;
  onNext: () => void;
  maxIndex: number;
  displayMenuItems: typeof menuItems;
}) {
  return (
    <div
      className="box-border content-stretch relative p-0 shrink-0 w-full overflow-visible"
      data-name="Container"
    >
      {/* Navigation Arrows - 콘텐츠 끝에 반쯤 걸치게 배치 */}
      <div className="hidden lg:block">
        <button
          onClick={onPrev}
          disabled={currentIndex === 0}
          className="absolute -left-[30px] top-1/2 -translate-y-1/2 z-20 w-[60px] h-[60px] bg-white border border-[#999999] rounded-full flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <button
          onClick={onNext}
          disabled={currentIndex === maxIndex}
          className="absolute -right-[30px] top-1/2 -translate-y-1/2 z-20 w-[60px] h-[60px] bg-white border border-[#999999] rounded-full flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* 캐러셀 컨테이너 - 5개씩 정확히 보이도록 설정 */}
      <div className="overflow-hidden w-full">
        <div 
          className="flex flex-row gap-4 items-start justify-start transition-transform duration-300 ease-in-out"
          style={{ 
            transform: `translateX(calc(-${currentIndex} * (220px + 1rem)))`,
            width: 'max-content'
          }}
        >
          {displayMenuItems.map((item, index) => (
            <div key={index} className="flex justify-center lg:justify-start flex-shrink-0">
              <ProductCard image={item.image} name={item.name} />
            </div>
          ))}
        </div>
      </div>

      {/* 모바일 네비게이션 */}
      <div className="lg:hidden flex items-center justify-center gap-4 mt-6">
        <button 
          onClick={onPrev}
          disabled={currentIndex === 0}
          className="w-12 h-12 rounded-full border border-[#999999] bg-white flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <span className="text-sm text-[#666666]">
          {currentIndex + 1} / {maxIndex + 1}
        </span>
        <button 
          onClick={onNext}
          disabled={currentIndex === maxIndex}
          className="w-12 h-12 rounded-full border border-[#999999] bg-white flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

// Menu More Button
function ButtonContainer8({ onMenuClick }: { onMenuClick: () => void }) {
  return (
    <button
      onClick={onMenuClick}
      className="bg-[#cacc2f] hover:bg-[#b8bb28] box-border content-stretch flex flex-row gap-4 items-center justify-center px-6 py-4 relative rounded-[100px] shrink-0 w-60 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg transform"
      data-name="Button Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[20px] text-left text-neutral-950 text-nowrap tracking-[-0.4px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          메뉴 더보기
        </p>
      </div>
      <div className="flex h-[14px] items-center justify-center relative shrink-0 w-[14px]">
        <div className="flex-none rotate-[90deg]">
          <div className="relative size-3.5">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 14 11"
              >
                <path
                  d={svgPaths.p3ed61000}
                  fill="var(--fill-0, #333333)"
                  id="Polygon 1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}

// Menu Section
function Section3({ onMenuClick }: { onMenuClick: () => void }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState<'all' | 'meals' | 'snacks' | 'drinks'>('meals');
  
  // 활성 탭에 따라 메뉴 아이템 필터링
  const getFilteredMenuItems = () => {
    if (activeTab === 'all') {
      return menuItems;
    }
    return menuItems.filter(item => item.category === activeTab);
  };

  const displayMenuItems = getFilteredMenuItems();

  const getItemsPerView = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= 1024) return 5; // 데스크톱에서 5개씩 보이도록
      if (window.innerWidth >= 768) return 3;
      if (window.innerWidth >= 640) return 2;
      return 1;
    }
    return 5;
  };

  const itemsPerView = getItemsPerView();
  const maxIndex = Math.max(0, displayMenuItems.length - itemsPerView);

  const nextSlide = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  // 탭 변경 시 인덱스 리셋
  const handleTabChange = (tab: 'all' | 'meals' | 'snacks' | 'drinks') => {
    setActiveTab(tab);
    setCurrentIndex(0);
  };

  return (
    <div
      className="flex flex-col gap-20 items-start justify-start pb-0 pt-20 px-0 w-full"
      data-name="Section"
    >
      <Container11 activeTab={activeTab} onTabChange={handleTabChange} />
      <Container12 
        currentIndex={currentIndex}
        onPrev={prevSlide}
        onNext={nextSlide}
        maxIndex={maxIndex}
        displayMenuItems={displayMenuItems}
      />
      <div className="flex justify-center w-full">
        <ButtonContainer8 onMenuClick={onMenuClick} />
      </div>
    </div>
  );
}

// Menu Background
function Background1() {
  return (
    <div
      className="absolute h-[min(437px,_30vh)] top-0 translate-x-[-50%] w-[min(4253.22px,_400vw)] opacity-50 rotate-180 z-0"
      data-name="Background"
      style={{ left: "calc(50% + 0.305px)" }}
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 2127 437"
      >
        <g id="Background">
          <path
            d={svgPaths.p9d12100}
            fill="url(#paint0_linear_1_465)"
            fillOpacity="0.5"
            id="Rectangle 16"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_1_465"
            x1="1063.3"
            x2="1063.3"
            y1="101.941"
            y2="436.941"
          >
            <stop offset="0.298077" stopColor="#FFD844" stopOpacity="0" />
            <stop offset="1" stopColor="#D4A533" stopOpacity="0.8" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export function MenuSection({ onMenuClick }: MenuSectionProps) {
  return (
    <div
      className="bg-[#ffffff] relative shrink-0 w-full"
      data-name="Main Container"
    >
      <div className="overflow-clip relative size-full">
        <Background1 />
        <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start left-1/2 px-4 py-[120px] relative translate-x-[-50%] w-[min(1280px,_calc(100vw_-_40px))] z-10">
          <Section3 onMenuClick={onMenuClick} />
        </div>
      </div>
    </div>
  );
}